export const capitalizedFirstLetter = (text) => text.charAt(0).toUpperCase() + text.slice(1);
export const capitalizedEveryFirstLetter = (text) => {
    const array = text.split(' ');

    const capitalizedArray = array.map((word) => capitalizedFirstLetter(word));

    return capitalizedArray.join(' ');
};
